var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modalAction
    ? _c(
        "b-modal",
        {
          staticClass: "modalZIndex",
          attrs: {
            id: _vm.id,
            title: _vm.modalAction.Title,
            size: "xl",
            "no-close-on-backdrop": ""
          },
          on: { show: _vm.show },
          scopedSlots: _vm._u(
            [
              {
                key: "modal-footer",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "w-100 text-right" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "danger", size: "sm" },
                            on: {
                              click: function($event) {
                                return _vm.closeModal()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("index.close")) +
                                "\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              id: "findButton",
                              size: "sm",
                              variant: "success"
                            },
                            on: { click: _vm.getList }
                          },
                          [
                            _c("i", { staticClass: "fa fa-search" }),
                            _vm._v(_vm._s(_vm.$t("index.Convert.find")))
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              disabled:
                                !_vm.form ||
                                !_vm.form.RecordId ||
                                _vm.form.RecordId === 0,
                              variant: "primary",
                              size: "sm"
                            },
                            on: {
                              click: function($event) {
                                return _vm.submitModal()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("index.approve")) +
                                "\n        "
                            ),
                            _vm.showLoading
                              ? _c("b-spinner", {
                                  attrs: { small: "", variant: "primary" }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ],
            null,
            false,
            4130166326
          )
        },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("index.Convert.DocumentNumber"),
                        md: "4",
                        lg: "4"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.documentNumber,
                          callback: function($$v) {
                            _vm.documentNumber = $$v
                          },
                          expression: "documentNumber"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-table", {
                        attrs: {
                          items: _vm.list,
                          fields: _vm.fields,
                          "sticky-header": "700px",
                          "select-mode": "single",
                          selectable: "",
                          busy: _vm.tableBusy
                        },
                        on: { "row-selected": _vm.onRowSelected },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "head()",
                              fn: function(data) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t(data.label)) +
                                      "\n          "
                                  )
                                ]
                              }
                            },
                            {
                              key: "table-busy",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center text-danger my-2"
                                    },
                                    [
                                      _c("b-spinner", {
                                        staticClass: "align-middle"
                                      })
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "cell(show_details)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            size: "sm",
                                            variant: "success",
                                            disabled: !row.rowSelected
                                          },
                                          on: { click: row.toggleDetails }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-arrow-down"
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "row-details",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "sales-return-invoice-convert"
                                    },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "NextFormGroup",
                                            {
                                              attrs: {
                                                title: _vm.$t(
                                                  "index.Convert.Code"
                                                ),
                                                md: "4",
                                                lg: "4"
                                              }
                                            },
                                            [
                                              _c("NextInput", {
                                                model: {
                                                  value:
                                                    _vm.selectedItem
                                                      .InvoiceNumber,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.selectedItem,
                                                      "InvoiceNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "selectedItem.InvoiceNumber"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "NextFormGroup",
                                            {
                                              attrs: {
                                                title: _vm.$t(
                                                  "index.Convert.WarehouseId"
                                                ),
                                                md: "4",
                                                lg: "4"
                                              }
                                            },
                                            [
                                              _c("NextDropdown", {
                                                attrs: {
                                                  url:
                                                    "VisionNextWarehouse/api/Warehouse/AutoCompleteSearch",
                                                  searchable: ""
                                                },
                                                model: {
                                                  value: _vm.warehouse,
                                                  callback: function($$v) {
                                                    _vm.warehouse = $$v
                                                  },
                                                  expression: "warehouse"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "NextFormGroup",
                                            {
                                              attrs: {
                                                title: _vm.$t(
                                                  "index.Convert.DocumentNumber"
                                                ),
                                                md: "4",
                                                lg: "4"
                                              }
                                            },
                                            [
                                              _c("NextInput", {
                                                model: {
                                                  value:
                                                    _vm.selectedItem
                                                      .DocumentNumber,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.selectedItem,
                                                      "DocumentNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "selectedItem.DocumentNumber"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("b-table", {
                                        attrs: {
                                          id: "convert-detail-list",
                                          items: _vm.form.InvoiceLines,
                                          fields: _vm.detailFields,
                                          "sticky-header": "500px"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "head()",
                                              fn: function(data) {
                                                return [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(data.label)
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              }
                                            },
                                            {
                                              key: "cell(SalesQuantity1)",
                                              fn: function(data) {
                                                return [
                                                  _c("NextInput", {
                                                    ref: "NextTextInput",
                                                    attrs: {
                                                      type: "number",
                                                      "input-class":
                                                        !data.item
                                                          .UsedQuantity ||
                                                        data.item.UsedQuantity <
                                                          1 ||
                                                        data.item.UsedQuantity <
                                                          data.item
                                                            .SalesQuantity1
                                                          ? "error"
                                                          : ""
                                                    },
                                                    model: {
                                                      value:
                                                        data.item
                                                          .SalesQuantity1,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          data.item,
                                                          "SalesQuantity1",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data.item.SalesQuantity1"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          259158902
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          931406109
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-639b20ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-639b20ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actions/SalesReturnInvoiceConvertModal.vue
// module id = null
// module chunks = 